import { Box, Text } from '@chakra-ui/react';
import TeamsService from 'api/services/TeamsService';
import Dialog from 'components/Dialog';
import InviteMembersDropdown, { TOption } from 'components/InviteMembersDropdown';
import useRedirectURL from 'hooks/useRedirectURL';
import showMessage from 'providers/NoticeProvider/showMessage';
import { ReactElement, useState } from 'react';
import { ROUTES } from 'routes';

type TProps = {
    teamId: string;
    companyId: string;
    title: string;
    trigger: ReactElement;
};

const InviteMemberDialog = ({ teamId, companyId, trigger, title }: TProps) => {
    // const [role, setSelectedOption] = useState(null);
    const [open, setOpen] = useState(false);

    const [emails, setEmails] = useState<TOption[]>([]);
    const redirectUrl = useRedirectURL(ROUTES.invited.fullPath);
    const [loading, setLoading] = useState(false);

    // const handleChange = (value: any) => {
    //     setSelectedOption(value);
    // };

    const handleSubmit = async () => {
        // setSelectedOption([]);
        // setEmails(null);
        // showMessage('The invite has been successfully sent.');
        try {
            setLoading(true);
            await TeamsService.inviteMember({
                email: emails[0].label,
                teamId,
                companyId,
                url: redirectUrl,
            })
                .then(() => {
                    showMessage('The invite has been successfully sent.');
                    setOpen(false);
                })
                .finally(() => {
                    setLoading(false);
                });
        } catch (error) {
            return false;
        }
    };

    // const disabled = !role || !emails?.length;
    const disabled = false;

    return (
        <Dialog
            forceIsOpen={open}
            setOpen={setOpen}
            size="lg"
            title="Invite member"
            trigger={trigger}
            submitText="Send invites"
            onSubmit={handleSubmit}
            disabled={disabled}
            withoutCancel
            loading={loading}
        >
            <Box>
                <Text color="gray.500" fontSize="16px" fontWeight={500} lineHeight={1.5} mb="24px">
                    Invitations to team:{' '}
                    <Text color="gray.900" as="span">
                        {title}
                    </Text>
                </Text>
                <InviteMembersDropdown value={emails} setValue={setEmails} />
                {/* <RoleDropdown sx={{ mt: '24px' }} label="Invite as" value={role} onChange={handleChange} /> */}
            </Box>
        </Dialog>
    );
};

export default InviteMemberDialog;
